import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=0516503c"
import script from "./categories.vue?vue&type=script&lang=js"
export * from "./categories.vue?vue&type=script&lang=js"
import style0 from "./categories.vue?vue&type=style&index=0&id=0516503c&prod&lang=css"
import style1 from "./categories.vue?vue&type=style&index=1&id=0516503c&prod&lang=css"
import style2 from "./categories.vue?vue&type=style&index=2&id=0516503c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports